// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaxesView_container__GixJf {
  width: 85%;
  padding: 30px;
  margin-left: auto;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/styles/TaxesView.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".container {\n  width: 85%;\n  padding: 30px;\n  margin-left: auto;\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TaxesView_container__GixJf`
};
export default ___CSS_LOADER_EXPORT___;
